export default __webpack_public_path__ + "static/media/exit-success.da2767ce.svg";